import { z } from 'zod';

export const TextStyleFormSchema = z.object({
  updatedAt: z.string().optional(),
  status: z.string().optional(),
  name: z
    .string()
    .min(3, 'Name must be at least 3 characters long')
    .max(100, 'Name cannot exceed 100 characters')
    .regex(/^[a-zA-Z0-9 ]+$/, { message: 'Only letters and numbers are allowed' }),
  content: z
    .string()
    .min(1, 'Content is required')
    .max(5000, 'Content cannot exceed 5000 characters'),
});

export type TextStyleFormValues = z.infer<typeof TextStyleFormSchema>;
